// store/authStore.js
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import CryptoJS from "crypto-js";

// Clé secrète pour le chiffrement AES
const SECRET_KEY = "1234567890abcdef"; // Assure-toi que cette clé est sécurisée en production

// Fonction pour chiffrer les données
const encryptData = (data) => {
  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    SECRET_KEY
  ).toString();
  return encrypted;
};

// Fonction pour déchiffrer les données
const decryptData = (encryptedData) => {
  const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
  const decrypted = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decrypted;
};

// Stockage personnalisé avec chiffrement
const encryptedLocalStorage = {
  getItem: (name) => {
    const encryptedData = localStorage.getItem(name); // Récupère les données chiffrées
    if (!encryptedData) return null;
    return decryptData(encryptedData); // Déchiffre les données
  },
  setItem: (name, value) => {
    const encryptedData = encryptData(value); // Chiffre les données
    localStorage.setItem(name, encryptedData); // Stocke les données chiffrées
  },
  removeItem: (name) => {
    localStorage.removeItem(name); // Supprime les données
  },
};

// Création du store Zustand avec persistance et chiffrement
const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      token: null,
      expiresAt: null,
      login: (userData, token, expiresAt) =>
        set({ user: userData, token: token, expiresAt: expiresAt }),
      logout: () => {
        // Nettoyer le state
        set({ user: null, token: null, expiresAt: null });
        // Nettoyer explicitement le localStorage
        localStorage.removeItem('auth-storage');
        // Recharger la page pour s'assurer que tout état est réinitialisé
      },
      setToken: (token, expiresAt) =>
        set({ token: token, expiresAt: expiresAt }),
      clearToken: () => set({ token: null, expiresAt: null }),
    }),
    {
      name: "auth-storage", // Nom unique pour le stockage
      storage: createJSONStorage(() => encryptedLocalStorage), // Utilise le stockage personnalisé avec chiffrement
    }
  )
);

export default useAuthStore;
